
import Vue from 'vue';
import {Subscription} from 'rxjs';
import {stripIndent} from 'common-tags';

import * as RootStore from '@/store/search/';
import * as InterfaceStore from '@/store/search/form/interface';

import { selectedSubCorpus$ } from '@/store/search/streams';

import QueryFormSearch from '@/pages/search/form/QueryFormSearch.vue';
import QueryFormExplore from '@/pages/search/form/QueryFormExplore.vue';
import QueryFormFilters from '@/pages/search/form/QueryFormFilters.vue';
import QueryFormSettings from '@/pages/search/form/QueryFormSettings.vue';

import History from '@/pages/search/History.vue';

import * as BLTypes from '@/types/blacklabtypes';
import {ApiError} from '@/types/apptypes';

export default Vue.extend({
	components: {
		QueryFormExplore,
		QueryFormSearch,
		QueryFormFilters,
		QueryFormSettings,
		History
	},
	data: () => ({
		subscriptions: [] as Subscription[],
		subCorpusStats: null as null|BLTypes.BLDocResults,
		error: null as null|ApiError,

		settingsOpen: false,
		historyOpen: false,

	}),
	computed: {
		queryBuilderVisible(): boolean { return RootStore.get.queryBuilderActive(); },
		filtersVisible(): boolean { return RootStore.get.filtersActive(); },
		activeForm: {
			get: InterfaceStore.get.form,
			set: InterfaceStore.actions.form
		},
	},
	methods: {
		reset: RootStore.actions.reset,
		submit() {
			if (this.activeForm === 'explore' && this.subCorpusStats && this.subCorpusStats.summary.tokensInMatchingDocuments! > 5_000_000) {
				const msg = stripIndent`
					You have selected a subcorpus of over ${(5_000_000).toLocaleString()} tokens.
					Please note that this query, on first execution, may take a considerable amount of time to complete.
					Proceed with caution.

					Continue?`;

				if (!confirm(msg)) {
					return;
				}
			}
			if (document.activeElement) {
				(document.activeElement as HTMLInputElement).blur();
			}
			RootStore.actions.searchFromSubmit();
		}
	},
	created() {
		this.subscriptions.push(selectedSubCorpus$.subscribe(v => {
			this.subCorpusStats = v.value || null;
			this.error = v.error || null;
		}));
	},
	destroyed() {
		this.subscriptions.forEach(s => s.unsubscribe());
	}
});
